import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type ProductCategoryTagsProps = {
  tags: string[]
}

const MAX_VISIBLE_TAGS = 2

const TagsWrapper = withCitrusTheme(Box, () => ({
  maxWidth: 'calc(100% - 2rem)',
  overflow: 'hidden',
  transform: 'translateY(-50%)',
  zIndex: 1,
}))

const TagText = withCitrusTheme(Text, () => ({
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))

export const ProductCategoryTags = ({ tags }: ProductCategoryTagsProps) => {
  const visibleTags = tags.slice(0, MAX_VISIBLE_TAGS)

  if (!visibleTags.length) {
    return null
  }

  return (
    <TagsWrapper
      data-testid="product-category-tags"
      position={DisplayPosition.Absolute}
      top="0"
      left="1rem"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      minWidth="0"
      gap={1}
    >
      {visibleTags.map((tag) => (
        <Box
          key={tag}
          display={Display.Flex}
          alignItems={AlignItems.Center}
          minWidth="0"
          flexGrow={0}
          flexShrink={1}
          flexBasis="auto"
          height="24px"
          paddingH={2}
          bg={Color.ColdGrey_50}
          borderRadius={1.5}
        >
          <TagText display={Display.Block} size={1}>
            {tag}
          </TagText>
        </Box>
      ))}
    </TagsWrapper>
  )
}
